import createInstance from "./interceptors";
import axios from "axios";

const API_URL = process.env.VUE_APP_API_BASE_URL + "/api/user";

class UserService {
  save(data) {
    const instance = createInstance();

    return instance.post(API_URL, data).then((response) => {
      return response.data;
    });
  }

  delete(data) {
    const instance = createInstance();

    return instance
      .delete(API_URL, {
        data: {
          data: data,
        },
      })
      .then((response) => {
        return response.data;
      });
  }

  getTerms() {
    let user = JSON.parse(localStorage.getItem("user"));
    return user.default_password;
  }

  setUser(user) {
    localStorage.setItem("user", JSON.stringify(user));
  }

  getUser() {
    // Retorna o usuário logado atualmente
    return JSON.parse(localStorage.getItem("user"));
  }

  removeUser() {
    localStorage.removeItem("user");
  }

  requestNewPassword(email) {
    return axios
      .post(API_URL + "/requestNewPassword", {
        email: email,
      })
      .then((response) => {
        return response.data;
      });
  }

  changePassword(user) {
    const instance = createInstance();

    return instance
      .post(API_URL + "/changepassword/" + user.id, {
        password: user.password,
      })
      .then((response) => {
        return response.data;
      });
  }

  forgotPassword(data) {
    const instance = createInstance();

    return instance
      .post(API_URL + "/forgotPassword/" + data.token, {
        password: data.password,
      })
      .then((response) => {
        return response.data;
      });
  }

  find(userId) {
    const instance = createInstance();

    return instance.get(API_URL + "/" + userId).then((response) => {
      return response.data;
    });
  }

  logout(user) {
    const instance = createInstance();

    return instance
      .post(API_URL + "/logout", {
        user: user,
      })
      .then((response) => {
        return response.data;
      });
  }
}

export default new UserService();
